export default __webpack_public_path__ + "static/media/flop-hit_0002_thumb.f081c4cb.jpg";